import * as axios from 'axios';


export const LOGIN_START = "LOGIN_START";
export const LOGIN = "LOGIN";

export function login({email, password}) {
    return dispatch => {
        dispatch({
            type: LOGIN_START
        });
        const formData = new FormData;
        formData.append("email", email);
        formData.append("password", password);

        const payload = axios.post('/auth/login', formData);

        dispatch({
            type: LOGIN,
            payload
        })
    }
}

export const LOGOUT = "LOGOUT";

export function logout() {
    return dispatch => {
        axios.get("/auth/logout").then(() => {
            dispatch({
                type: LOGOUT,
            });
        },(error)=>{
            dispatch({
                type: LOGOUT,
                payload: {error}
            });
        })
    }
}

export const IDENTITY_START = "IDENTITY_START";
export const IDENTITY = "IDENTITY";

export function identityCheck() {
    return dispatch => {
        dispatch({
            type: IDENTITY_START
        });

        const payload = axios.get("/api/account/identity");
        dispatch({
            type: IDENTITY,
            payload
        });
    }
}

export const GET_USER_LOGIN_STATUS_START = "GET_USER_LOGIN_STATUS_START";
export const GET_USER_LOGIN_STATUS = "GET_USER_LOGIN_STATUS";

export const getUserLoginStatus = () => dispatch => {
    dispatch({type: GET_USER_LOGIN_STATUS_START});

    const payload = axios.get('/api/auth-status');
    dispatch({
        type: GET_USER_LOGIN_STATUS,
        payload
    });
};

export const SESSION_EXPIRED = "SESSION_EXPIRED";

export const sessionExpired = () => ({type: SESSION_EXPIRED});

export const EXECUTE_RECAPTCHA_START = "EXECUTE_RECAPTCHA_START";
export const EXECUTE_RECAPTCHA = "EXECUTE_RECAPTCHA";

export const executeRecaptcha = (instance) => dispatch => {
    dispatch({type: EXECUTE_RECAPTCHA_START});
    instance.execute();

    const payload = axios.post(`/api/verify-recaptcha?response=${instance.getResponse()}&secret=${instance.props.sitekey}`);
    dispatch({
        type: EXECUTE_RECAPTCHA,
        payload
    });
};




// WEBPACK FOOTER //
// ./src/containers/login/LoginActions.js